import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        "count": 1,
        "route": "/services-1",
        "title": "Fire Extinguisher Services",
        "flaticon": "flaticon-city",
        "description": "Complete maintenance and refilling of all types of fire extinguishers to ensure instant readiness in emergencies."
    },
    {
        "count": 2,
        "route": "/services-2",
        "title": "Public Address (PA) System",
        "flaticon": "flaticon-decorating",
        "description": "Emergency announcements, evacuation guidance, and zone-wise voice alerts for maximum safety."
    },
    {
        "count": 3,
        "route": "/services-3",
        "title": "Hydrant & Sprinkler System Care",
        "flaticon": "flaticon-crane",
        "description": "Expert servicing and maintenance of fire hydrants, water spray, and sprinkler systems for complete fire coverage."
    },
    {
        "count": 4,
        "route": "/services-4",
        "title": "HVAC (Heating, Ventilation, and Air Conditioning)",
        "flaticon": "flaticon-decorating",
        "description": "Design, installation, and maintenance of efficient HVAC systems to ensure indoor air quality and climate control year-round."
    },
    {
        "count": 5,
        "route": "/services-5",
        "title": "Plumbing Solutions",
        "flaticon": "flaticon-pipe",
        "description": "Complete plumbing system planning, pipeline fitting, water supply solutions, and leak-proof drainage installations."
    },
    {
        "count": 6,
        "route": "/services-6",
        "title": "Full MEP Design & Installation Works",
        "flaticon": "flaticon-sketch",
        "description": "Comprehensive Mechanical, Electrical & Plumbing services, from detailed design to final execution for residential and commercial projects."
    },
    {
        "count": 7,
        "route": "/services-7",
        "title": "Signage Works",
        "flaticon": "flaticon-container",
        "description": "Design, fabrication, and installation of safety and informational signage for fire exits, emergency procedures, and equipment marking — ensuring clear guidance across all facilities."
    },
    {
        "count": 8,
        "route": "/services-8",
        "title": "CCTV Surveillance",
        "flaticon": "flaticon-entrance",
        "description": "Design, supply, and installation of high-definition CCTV systems for 24/7 surveillance, ensuring complete coverage and security of your premises."
    },
    {
        "count": 9,
        "route": "/services-9",
        "title": "Fire Alarm System",
        "flaticon": "flaticon-null-1",
        "description": "Early fire detection, rapid alerts, and integrated emergency response to safeguard lives and property."
    },
    {
        "count": 10,
        "route": "/services-10",
        "title": "Door Access Control",
        "flaticon": "flaticon-house",
        "description": "Controlled access, monitored entries, and unauthorized entry prevention—your first line of defense starts at the door."
    }

]

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');


class OurServices4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator text-white">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6" style={{ display: 'flex' }}>
                                    <div
                                        className="mt-icon-box-wraper p-a30 center m-b30 bg-white"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flex: 1,
                                            width: '100%',
                                        }}
                                    >
                                        <div
                                            className="mt-icon-box-sm inline-icon text-primary m-b20 radius bg-primary scale-in-center bg-moving"
                                            style={{ backgroundImage: 'url(' + img2 + ')' }}
                                        >
                                            <span className="icon-cell text-secondry">
                                                <i className={item.flaticon} />
                                            </span>
                                        </div>

                                        <div className="icon-content" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">
                                                {item.title}
                                            </h4>
                                            <p>{item.description}</p>
                                            <NavLink
                                                to={item.route}
                                                className="site-button-link"
                                                data-hover="Read More"
                                                style={{ marginTop: 'auto' }} // <- Pushes to bottom
                                            >
                                                Read More <i className="fa fa-angle-right arrow-animation" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </>
        );
    }
};

export default OurServices4;